import { Flex, Image, Input } from '@apia/theme';
import { useState } from 'react';
import { IconButton } from './buttons';
import { getVariant } from '@apia/theme';
import { getLabel } from '@apia/util';

export const Captcha = ({
  name,
  imageUrl,
  onChange,
  value,
  className,
}: {
  name: string;
  className?: string;
  imageUrl: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  value: string;
}) => {
  const [imgSrc, setImgSrc] = useState<string>(`${imageUrl}?t=${Date.now()}`);

  const handleSyncClick = () => {
    // IMG reload
    setImgSrc(`${imageUrl}?t=${Date.now()}`);
  };

  return (
    <Flex
      sx={{
        flexDirection: 'column',
      }}
      className="captcha__field"
      {...getVariant('layout.common.forms.captcha')}
    >
      <Flex className="captcha__imageContainer">
        <Image alt="" src={imgSrc} />
      </Flex>
      <Flex className={`captcha__inputContainer ${className ?? ''}`}>
        <Input
          autoComplete="off"
          name={name}
          onChange={onChange}
          value={value}
        />

        <Flex className="captcha__buttons">
          <IconButton
            icon="Refresh"
            type="button"
            aria-label={getLabel('lblCaptchaActivateAudio').text}
            onClick={handleSyncClick}
          ></IconButton>
          <IconButton
            icon="Volume"
            type="button"
            aria-label={getLabel('lblCaptchaActivateAudio').text}
            onClick={() => {}}
          ></IconButton>
        </Flex>
      </Flex>
    </Flex>
  );
};
